import * as _ from 'underscore';
import { Notification } from './notification';
import { StudioNotificationState, NotificationType } from '../enums';
import { StudioNotificationOptions } from '../interfaces/options';
import { DefaultStudioNotificationOptions } from '../const/defaultOptions/studioNotification';

export class StudioNotification extends Notification {
	private css: KnockoutComputed<String>;
	private state: KnockoutObservable<StudioNotificationState>;
	private _title: KnockoutObservable<string>;
	private title: KnockoutComputed<string>;
	private element: KnockoutObservable<Element>;
	private offset: KnockoutObservable<string>;
	private okClick: () => void;
	private closeClick: () => void;
	private duration: number;
	private remaining: number;
	private start: Date;
	private timeout: number;
	constructor() {
		super(DefaultStudioNotificationOptions);
		this.duration = 0;
		this.remaining = this.timeout = this.start = null;
		this.offset = ko.observable<string>();
		this.element = ko.observable<Element>();
		this.state = ko.observable<StudioNotificationState>(StudioNotificationState.Closed);
		this._title = ko.observable<string>();
		this.title = ko.pureComputed(
			() => (this._title() ? this._title() : NotificationType[this._type()])
		);
		this.css = ko.pureComputed(() =>
			StudioNotificationState[this.state()].toLowerCase().concat(' ', this.type())
		);
	}
	public show = (options: StudioNotificationOptions) => {
		this.duration = 0;
		this.remaining = this.start = null;
		options = _.defaults(options || {}, DefaultStudioNotificationOptions);
		this.clearTimeout();
		this.state(StudioNotificationState.Repositioning);
		this._title(options.title);
		this.okClick = options.okClick;
		this.closeClick = options.closeClick;
		this.initNotification(options);
		if (options.duration > 0) {
			this.duration = options.duration * 1000;
			this.remaining = this.duration;
			this.start = new Date();
			this.timeout = setTimeout(this.close, this.duration);
		}
		this.offset(this.element().clientWidth + 'px');

		setTimeout(() => {
			this.state(StudioNotificationState.Open);
		});
	};
	public close = (data?: any) => {
		if (this.element()) {
			this.clearTimeout();
			this.offset(this.element().clientWidth + 'px');
			setTimeout(() => {
				this.state(StudioNotificationState.Closed);
			});

			// User clicks have to pass 'data' argument to get called back
			if (this.closeClick && data) this.closeClick();
		}
	};
	public pauseClose = () => {
		if (this.duration > 0) {
			this.clearTimeout();
			this.remaining -= new Date().valueOf() - this.start.valueOf();
		}
	};
	public resumeClose = () => {
		if (this.duration > 0) {
			if (this.remaining > 0) {
				this.clearTimeout();
				this.start = new Date();
				this.timeout = setTimeout(this.close, this.remaining);
			} else {
				this.close();
			}
		}
	};
	private clearTimeout() {
		if (this.timeout) {
			clearTimeout(this.timeout);
			this.timeout = null;
		}
	}
}
